import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from '../../apiClient';

export type SlackChannel = {
  id: string;
  name: string;
  workspace: string;
  anniePresent: boolean;
  memberCount: number;
  description?: string;
};

export type SlackChannelsResponse = {
  channels: SlackChannel[];
  connectedState: boolean;
};

export const slackQueries = {
  all: () => ['integrations/messaging/slack/channels/'],
  byProject: (projectId: string) => [...slackQueries.all(), projectId],
  listChannels: (projectId: string) =>
    queryOptions({
      queryKey: ['integrations/messaging/slack/channels/', projectId],
      queryFn: async () => {
        const slackChannels = await listSlackChannels(projectId);

        return {
          ...slackChannels,
          connectedState: slackChannels.channels.length > 0,
        };
      },
    }),
} as const;

export const listSlackChannels = async (
  projectId: string,
): Promise<SlackChannelsResponse> => {
  const getResponse = await fetchBackend(
    `/integrations/messaging/slack/channels/${projectId}`,
    {
      method: 'GET',
    },
  );

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  return (await getResponse.json()) as SlackChannelsResponse;
};
